export default __webpack_public_path__ + "static/media/RTR200FI_Posterior.4d7207bb.webp";